import createIcon from "../createIcon";
export var ArrowDownConfig = {
  displayName: "ArrowDown",
  attrs: {
    fill: "currentColor"
  },
  css: {
    display: "inline-block",
    verticalAlign: "middle",
    overflow: "hidden",
    maxHeight: "100%",
    maxWidth: "100%",
    margin: "auto"
  },
  titleKey: "ArrowDown-title",
  viewBox: "0 0 512 512",
  labelledby: "icon-title-ArrowDown",
  body: [{
    type: "path",
    props: {
      d: "M277.375 85v259.704l119.702-119.702L427 256 256 427 85 256l29.924-29.922 119.701 118.626V85h42.75z",
      key: "k0"
    }
  }]
};
export default createIcon(ArrowDownConfig);